import { render, staticRenderFns } from "./SynergismUi.vue?vue&type=template&id=bf1bfb3a&scoped=true&"
import script from "./SynergismUi.vue?vue&type=script&lang=js&"
export * from "./SynergismUi.vue?vue&type=script&lang=js&"
import style0 from "./SynergismUi.vue?vue&type=style&index=0&id=bf1bfb3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1bfb3a",
  null
  
)

export default component.exports